export default {
  clients: 'Client list',
  verifications: 'Verification requests',
};
